import styled from 'styled-components';

import { Loading } from '../../../components/Loading';
import { Container } from '../../../GlobalComponents/Container';
import { Flex } from '../../../GlobalComponents/Flex';
import { Title } from '../../../GlobalComponents/Title';
import { useAppSelector } from '../../../reduxstore/hooks';
import PointsWidget from './containers/PointsWidget';
import RewardsDashboard from './containers/RewardsDashboard';

const Rewards = (): JSX.Element => {
	const { claimed_rewards, reward_progress } = useAppSelector(
		state => state.accountReducer.profile
	);

	const drinksReward = reward_progress.find(
		rewards => rewards.reward_plan.name === '13th Free Drink'
	);

	const beansReward = reward_progress.find(
		rewards => rewards.reward_plan.name === 'Whole Bean Coffee'
	);

	return (
		<Container>
			{drinksReward && beansReward ? (
				<Container>
					<Flex $flexDirection="column" $rowGap="36px">
						<Flex $flexDirection="column">
							<Title>My Points</Title>
							<Flex $flexDirection="column" $rowGap="36px">
								<PointsWidget
									type="drink"
									maxPoints={parseInt(
										drinksReward.reward_plan.threshold
									)}
									points={parseInt(drinksReward.points)}
									title={'Drink Points'}
								/>
								<DividerWrapper>
									<Divider />
								</DividerWrapper>

								<PointsWidget
									type="bean"
									maxPoints={parseInt(
										beansReward.reward_plan.threshold
									)}
									points={parseInt(beansReward.points)}
									title={'Whole Bean Points'}
								/>
							</Flex>
						</Flex>
						<RewardsDashboard rewards={claimed_rewards} />
					</Flex>
					<div style={{ width: '100%', marginBottom: '48px' }} />
				</Container>
			) : (
				<Flex $alignItems="center" $justifyContent="center">
					<Loading />
				</Flex>
			)}
		</Container>
	);
};

export default Rewards;

const DividerWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

const Divider = styled.div`
	border: 0.5px solid #dcdcdc;
	width: 75%;
`;
